import React from 'react';
import configurationTags from '../SelectAssessmentTags/AssessmentConfigurationTags.json';
import FaBan from 'react-icons/lib/fa/ban';
import { findSelectedAssessmentTagFromSavedTags } from '../SelectAssessmentTags';

export default function ConfigurationCell({ onChange, cellData, configIndex, taskIndex, taskName, contentTags }) {

  const isUI = typeof cellData === 'object' && cellData.ui;
  const isBoolean = typeof cellData === 'boolean';

  if (isUI) {
    return <td className='config-table-body-data-cell' key={'cell_' + taskName + configIndex}>
      {cellData.ui}
    </td>;
  }

  // we need to determine if there is an override for this cell and handle only the required and banned cases for display
  if (isBoolean) {

    // get the override value for this cell
    const assessmentTag = findSelectedAssessmentTagFromSavedTags(contentTags);
    const override = configurationTags.find(tag => tag.value === assessmentTag)?.override?.[taskName]?.[configIndex];

    // check for required override
    if(override === 1) {
      return <td className='config-table-body-data-cell' key={'cell_' + taskName + configIndex}>
        Required
      </td>;
    }else if(override === 2) { // check for banned override
      return <td className='config-table-body-data-cell' key={'cell_' + taskName + configIndex}>
        <FaBan size="30" color="#ccc" />
      </td>;
    }
  }

  // if none of the above conditions are met, then return a checkbox based on the cellData value
  return <td className='config-table-body-data-cell' key={'cell_' + taskName + configIndex}>
    <input type="checkbox" name={taskName + configIndex} checked={cellData} onChange={() => onChange(taskIndex, configIndex)} />
  </td>;
}